import { render, staticRenderFns } from "./address_list.vue?vue&type=template&id=481d6400&scoped=true&"
import script from "./address_list.vue?vue&type=script&lang=js&"
export * from "./address_list.vue?vue&type=script&lang=js&"
import style0 from "./address_list.vue?vue&type=style&index=0&id=481d6400&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481d6400",
  null
  
)

export default component.exports